// Domain access control for restricting application access

// Authorized domains that can access the application
export const AUTHORIZED_DOMAINS = [
  'entwinedsignage.com.au',
  'entwined.com.au',
  // Add more authorized domains as needed
];

// Check if user's email domain is authorized
export const isAuthorizedDomain = (email) => {
  if (!email) return false;
  
  const domain = email.split('@')[1]?.toLowerCase();
  return AUTHORIZED_DOMAINS.includes(domain);
};

// Check if user can access the application
export const canAccessApplication = (user) => {
  if (!user || !user.email) return false;
  
  return isAuthorizedDomain(user.email);
};

// Get user's domain from email
export const getUserDomain = (email) => {
  if (!email) return null;
  return email.split('@')[1]?.toLowerCase();
};

// Validate domain access and return error message if unauthorized
export const validateDomainAccess = (user) => {
  if (!user || !user.email) {
    return {
      allowed: false,
      reason: 'No user email provided'
    };
  }
  
  if (!isAuthorizedDomain(user.email)) {
    return {
      allowed: false,
      reason: `Access denied. Your domain (${getUserDomain(user.email)}) is not authorized to use this application. Please contact your administrator.`
    };
  }
  
  return {
    allowed: true,
    domain: getUserDomain(user.email)
  };
};

// Get list of authorized domains for display
export const getAuthorizedDomainsList = () => {
  return AUTHORIZED_DOMAINS;
}; 